import { render, staticRenderFns } from "./CertResultM.vue?vue&type=template&id=27103bef&scoped=true"
import script from "./CertResultM.vue?vue&type=script&lang=js"
export * from "./CertResultM.vue?vue&type=script&lang=js"
import style0 from "./CertResultM.vue?vue&type=style&index=0&id=27103bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27103bef",
  null
  
)

export default component.exports